
















































































































































































































































































































































































































import Vue from "vue";
import Fieldset from "@/components/ui/Fieldset.vue";
import Multiselect from "@/components/ui/Multiselect.vue";

import {
  Element,
  Foerderung,
  Handlungsbereich,
  InitiatorType,
  MassnahmenTraeger,
  Risikogewaesser,
  Schlagwort,
  Status,
  Teilbereich,
  VerwaltungsTraeger,
} from "@/types";
import { Massnahme } from "@/types/Massnahme";
import { alertError } from "@/services/ErrorAlert";
import { erklServiceInstance } from "@/services/ErklService";
import { kommunenServiceInstance } from "@/services/KommunenService";

import PubSub from "pubsub-js";
import CurrencyInput from "@/components/input/CurrencyInput.vue";

export default Vue.extend({
  name: "StammdatenTab",
  components: {
    CurrencyInput,
    Fieldset,
    Multiselect,
  },
  props: {
    /** maßnahme */
    value: {
      type: Object as () => Massnahme,
      required: true,
    },
    /** edit mode */
    editable: {
      type: Boolean,
      default: false,
    },
    agKommune: {
      type: [String],
      default: null,
      required: false,
    },
  },
  data: function () {
    return {
      isLoading: false,
      elemente: [] as Element[], // <-- just for dummy data
      schlagworte: [] as Schlagwort[],
      risikogewaesser: [] as Risikogewaesser[],
      initiatorTyps: [] as InitiatorType[],
      verwaltungsEbenen: [] as Element[],
      traeger: [] as MassnahmenTraeger[],
      regionalstellen: [] as Element[],
      handlungsbereiche: [] as Handlungsbereich[],
      teilbereiche: [] as Teilbereich[],
      status: [] as Status[],
      selectedVerwEbene: null as null | VerwaltungsTraeger,
      initionatorList: [] as Element[],
      massnahmenKommunen: [] as Element[],
      konzepte: [] as Element[],
      hochwasserpartenschaften: [] as Element[],
      gewaesserzweckverbaende: [] as Element[],
      konzepteKommunen: [] as Element[],
      foerderungen: [] as Foerderung[],
      isFoerderungLoading: false,
      // filteredTeilbereiche: [] as Teilbereich[],
    };
  },
  mounted() {
    this.isLoading = true;
    if (
      this.value !== undefined &&
      this.value.traeger !== undefined &&
      this.value.traeger.length > 0
    ) {
      this.selectedVerwEbene = this.value.traeger[0].verwaltungsTraeger;
    }

    Promise.all([
      erklServiceInstance
        .getSchlagworte()
        .then((data: Schlagwort[]) => (this.schlagworte = data)),

      erklServiceInstance
        .getRisikogewaesser()
        .then((data: Risikogewaesser[]) => (this.risikogewaesser = data)),

      erklServiceInstance
        .getInitiatorType()
        .then((data: InitiatorType[]) => (this.initiatorTyps = data)),

      erklServiceInstance
        .getVerwaltungsTraeger()
        .then((data: Element[]) => (this.verwaltungsEbenen = data)),

      erklServiceInstance
        .getRegionalstellen()
        .then((data: Element[]) => (this.regionalstellen = data)),

      erklServiceInstance
        .getHandlungsBereiche()
        .then((data: Handlungsbereich[]) => (this.handlungsbereiche = data)),

      erklServiceInstance
        .getStatus()
        .then((data: Status[]) => (this.status = data)),

      erklServiceInstance
        .getMassnahmenTraeger()
        .then((data: MassnahmenTraeger[]) => (this.traeger = data)),

      erklServiceInstance
        .getTeilbereiche()
        .then((data: Teilbereich[]) => (this.teilbereiche = data)),
    ])
      .catch((error: any) => alertError(error))
      .finally(() => (this.isLoading = false));

    Promise.all([
      erklServiceInstance.getMassnahmeKommunen().then((data: Element[]) => {
        this.massnahmenKommunen = data;
      }),
    ]).catch((error: any) => alertError(error));

    if (
      this.agKommune !== null &&
      this.agKommune !== undefined &&
      this.agKommune !== "undefined"
    ) {
      kommunenServiceInstance
        .getAgKommune(this.agKommune)
        .then((data: Element) => {
          this.value.agKommune = [data];
        });
    }
  },

  watch: {
    computedInitatorType: function () {
      if (this.value.initiatorType != undefined) {
        this.getInitiatorList();
      }
    },
    checkKosten: function () {
      if (this.value.kosten != undefined) {
        console.log("KOSTEN", this.value.kosten);
      }
    },
  },
  computed: {
    isNew() {
      if (this.value.id === undefined || this.value.id === null) return true;
      return false;
    },

    computedInitatorType(): any {
      return this.value.initiatorType;
    },
    filteredTraeger(): MassnahmenTraeger[] {
      if (
        this.value.verwaltungstraeger === undefined ||
        !Array.isArray(this.traeger) ||
        this.value.verwaltungstraeger.id === null
      ) {
        return [];
      }
      return this.traeger.filter(
        (traeger) =>
          traeger.verwaltungsTraeger.id === this.value.verwaltungstraeger.id,
      );
    },
    filteredTeilbereiche(): Teilbereich[] {
      if (
        this.value.handlungsbereich === undefined ||
        !Array.isArray(this.teilbereiche) ||
        this.value.handlungsbereich.id === null
      ) {
        return [];
      }
      return this.teilbereiche.filter(
        (traeger) =>
          traeger.handlungsbereich.id === this.value.handlungsbereich.id,
      );
    },
  },
  methods: {
    onSelectAGKommune: function (kommunen: Element[]) {
      if (kommunen !== null && kommunen.length) {
        erklServiceInstance
          .getKonzepteKommunen(kommunen[0]?.id)
          .then((data: Element[]) => {
            this.konzepteKommunen = data;
            if (
              this.value.konzept.length > 0 &&
              !this.konzepteKommunen.find(
                (x) => x.id == this.value.konzept[0].id,
              )
            )
              this.$emit("resetKonzept");
          });
      }
    },
    onSelectkonzepteKommunen: function (konzepteKommunen: Element[]) {
      //
    },
    bearbeiten: function (mode: boolean) {
      PubSub.publish("bearbeiten", mode);
    },
    onInputInitiator: function () {
      this.value.initiator = [];
    },
    onInputVerwaltungsmassnahmentraeger: function () {
      this.value.traeger = [];
    },
    onSaveAndValidate: function () {
      //disable validation until further notice https://gitlab.init.de/rlp-wasserwirtschaft/prj_ihsm/-/issues/158
      // if (ValidationService.validMassnahme(this.value)) {
      this.$emit("save");
      // }
    },
    getInitiatorList() {
      erklServiceInstance
        .getInitiators(this.value.initiatorType)
        .then((data: Element[]) => {
          this.initionatorList = data;
        });
    },
    /** is triggered by autocomplete input change */
    searchFoerderungen(value: string) {
      if (value && value.length >= 3) {
        this.isFoerderungLoading = true;
        erklServiceInstance
          .getFoerderungen(value)
          .then((data: Foerderung[]) => (this.foerderungen = data))
          .finally(() => (this.isFoerderungLoading = false));
      }
    },
  },
});
